(function () {
  document.documentElement.addEventListener(
    'cart:refresh',
    function (event) {
      var cart = event.detail && event.detail.cart;
      if (!cart || cart.item_count !== 0) return;
      if (event.detail && event.detail.__agEmptyCartRefetched) return;

      var drawer = document.getElementById('mini-cart');
      var sectionId = drawer && drawer.getAttribute('section');
      if (!sectionId) return;

      event.stopImmediatePropagation();

      fetch('/cart?section_id=' + encodeURIComponent(sectionId), {
        headers: { Accept: 'text/html' },
        credentials: 'same-origin'
      })
        .then(function (response) {
          if (!response.ok) throw new Error('Section fetch failed');
          return response.text();
        })
        .then(function (html) {
          if (!cart.sections) cart.sections = {};
          cart.sections['mini-cart'] = html;

          document.documentElement.dispatchEvent(
            new CustomEvent('cart:refresh', {
              bubbles: true,
              detail: Object.assign({}, event.detail, {
                cart: cart,
                __agEmptyCartRefetched: true
              })
            })
          );
        })
        .catch(function (error) {
          console.error('Mini cart empty state refresh failed:', error);

          document.documentElement.dispatchEvent(
            new CustomEvent('cart:refresh', {
              bubbles: true,
              detail: Object.assign({}, event.detail, {
                __agEmptyCartRefetched: true
              })
            })
          );
        });
    },
    true
  );
})();
